import styled from "styled-components";
import InfoIcon from '@mui/icons-material/Info';

export const AccordionContainer = styled.div`
        width:100%;
        margin-top: 2rem;
        background-color: #f3f3f3;
        display: flex;
        justify-content: center;
`

export const InfoIconStyled = styled(InfoIcon)`
    color: #028ecc;
    margin-right: .5rem;
`


